import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AllocationAndReceivingRunningBalanceComponent } from './allocation-and-receiving-running-balance.component';

const routes: Routes = [
{
  path:'**',
  component: AllocationAndReceivingRunningBalanceComponent
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AllocationAndReceivingRunningBalanceRoutingModule { }
